interface OrganizationSchema {
  '@context': string;
  '@type': string;
  name: string;
  url: string;
  description: string;
  sameAs?: string[];
}

interface WebSiteSchema {
  '@context': string;
  '@type': string;
  name: string;
  url: string;
  description: string;
  potentialAction: {
    '@type': string;
    target: string;
    'query-input': string;
  };
}

interface BreadcrumbItem {
  '@type': string;
  position: number;
  name: string;
  item: string;
}

export function getOrganizationSchema(): OrganizationSchema {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '国产精品精选推荐',
    url: 'https://anidndd.cn',
    description: '严选品质国货好物，从原料到工艺，从设计到服务，让每一件国产精品都成为您生活品质的见证。',
    sameAs: [
      'https://weibo.com/guochan-jingpin',
      'https://www.xiaohongshu.com/guochan-jingpin',
    ],
  };
}

export function getWebSiteSchema(): WebSiteSchema {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '国产精品精选推荐',
    url: 'https://anidndd.cn',
    description: '探索最值得信赖的国产精品，涵盖多品类优质国货好物，严选品质标准。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://anidndd.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };
}

export function getBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function getWebPageSchema(title: string, description: string, url: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description,
    url,
    isPartOf: {
      '@type': 'WebSite',
      name: '国产精品精选推荐',
      url: 'https://anidndd.cn',
    },
  };
}

export function getArticleSchema(
  title: string,
  description: string,
  url: string,
  datePublished: string,
  author: string,
  imageUrl: string
) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description,
    url,
    datePublished,
    author: {
      '@type': 'Person',
      name: author,
    },
    image: imageUrl,
    publisher: {
      '@type': 'Organization',
      name: '国产精品精选推荐',
      url: 'https://anidndd.cn',
    },
  };
}

export function getFAQSchema(questions: { question: string; answer: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questions.map((q) => ({
      '@type': 'Question',
      name: q.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: q.answer,
      },
    })),
  };
}